import React, { createContext } from 'react'
import nextCookie from 'next-cookies'
import Router from 'next/router'
import { basePath } from 'config/env_config'
import { logout, resetAuthCookies, validatePetanjoAuth } from 'services/authenticationService'
import { me } from 'services/userService'
import { getUserAddresses } from 'src/services/userService'
export const RootContext = createContext()

const KEY_REACT_NATIVE = 'reactnative'

export class RootProvider extends React.Component {
    loadingPool = []
    state = {
      isLoading: false,
      isMenuVisible: false,
      firstName: '',
      userAddresses: undefined,
      credentials: undefined,
      loginTitle: undefined,
      onAuthentication: undefined,
      actionModalStack: [],
      warningModalProps: {
        visible: false
      },
      isReactNative: false,
      modalSheetProps: {
        currentModal: {
          visible: false
        },
        modalQueue: []
      },
      isMobile: typeof window !== 'undefined' ? window.innerWidth <= 768 : false
    }

    hideLoader = () => {
      if (this.loadingPool.length) this.loadingPool.pop()
      if (this.loadingPool.length <= 0) {
        this.setState({ isLoading: false })
      }
    }

    showLoader = (hide) => {
      if (hide) return
      this.setState({ isLoading: true })
      this.loadingPool.push(true)
    }

    toggleMenu = () => {
      this.setState({
        isMenuVisible: !this.state.isMenuVisible
      })
    }

    getProfile = async () => {
      try {
        const user = await me()
        this.setUser(user)
      } catch (err) {
        if (err.response && err.response.status === 401) {
          // Ignora o erro de usuário não autenticado
          return
        }
        throw err
      }
    }

    getProfileAddresses = async () => {
      try {
        const addresses = await getUserAddresses()
        this.setUserAddresses(addresses)
      } catch (err) {
        if (err.response && err.response.status === 401) {
          // Ignora o erro de usuário não autenticado
          return
        }
        throw err
      }
    }

    logoutUser = async () => {
      await logout()
      this.setState({ firstName: '' })
    }

    closeMenuWhenNavigationStart = () => {
      this.setState({
        isMenuVisible: false
      })
    }

    shouldHideLoader = () => {
      const ROUTES_TO_HIDE_LOADER_MOBILE = ['/agendamentos/bem-vindo']
      return this.state.isMobile && ROUTES_TO_HIDE_LOADER_MOBILE.includes(Router.pathname)
    }

    validateAuthUrl = async () => {
      const { token, callback } = Router.query

      if (token && callback) {
        const vtexLogout = false
        await logout(vtexLogout)

        const { user, verified, email, authenticationToken, unauthenticated } = await validatePetanjoAuth(token)

        verified && this.setUser(user)

        if (!unauthenticated && !verified) {
          this.toggleModalSheet()
        }

        if (!unauthenticated && !verified) {
          this.setState({
            // isAuthModalVisible: !this.state.isAuthModalVisible,
            // authModalView: VIEWS.CONFIRM_NEW_ACCOUNT_INTEGRATION,
            // TO-DO: Implementar após criação do form de criação de conta
            props: {
              email,
              authenticationToken,
              thermAccepted: true
            }
          })
        }

        Router.push(callback.replace(basePath, ''))

        return !!user
      }

      return false
    }

    isReactNative = () => {
      const IS_REACT_NATIVE = 'true'
      const IS_NOT_REACT_NATIVE = 'false'

      const { reactnative } = Router.query
      const alreadyEntered = window.localStorage.getItem(KEY_REACT_NATIVE)
      if (reactnative === IS_REACT_NATIVE) window.localStorage.setItem(KEY_REACT_NATIVE, reactnative)

      const isReactNative = reactnative === IS_REACT_NATIVE || alreadyEntered === IS_REACT_NATIVE
      const isNotReactNative = reactnative === IS_NOT_REACT_NATIVE

      this.setState({
        isReactNative: isNotReactNative ? !isNotReactNative : isReactNative
      })
    }

    componentDidMount = async () => {
      this.showLoader(this.shouldHideLoader())
      this.isReactNative()
      const isValidated = await this.validateAuthUrl()
      try {
        const cookies = nextCookie({ req: {} })
        if ((cookies.authCookie || cookies.cobasiSession) && !isValidated) {
          await this.getProfile()
        }
      } catch (err) {
        // Tratamento para erro 431, onde os cookies estouram o limite de tamanho.
        // Limpamos os nossos cookies de auth, principalmente o X-Cobasi-User,
        // que não estava otimizado para ser menor.
        if (err.response && err.response.status === 431) {
          resetAuthCookies()
          await this.getProfile()
        }
      }
      this.hideLoader()

      Router.events.on('routeChangeStart', this.closeMenuWhenNavigationStart)
      Router.events.on('routeChangeStart', this.showLoadingOnRouteStart)
      Router.events.on('routeChangeComplete', this.hideLoadingOnRouteComplete)
    }

    componentWillUnmount () {
      Router.events.off('routeChangeStart', this.closeMenuWhenNavigationStart)
      Router.events.off('routeChangeStart', this.showLoadingOnRouteStart)
      Router.events.on('routeChangeComplete', this.hideLoadingOnRouteComplete)
    }

    showLoadingOnRouteStart = () => {
      if (!this.state.isLoading) {
        this.showLoader(this.shouldHideLoader())
      }
    }

    hideLoadingOnRouteComplete = () => {
      this.hideLoader()
    }

    setCredentials = ({ email, password, authorization } = {}) => {
      this.setState({
        credentials: {
          email,
          password,
          authorization
        }
      })
    }

    setResetPasswordData = ({ email, authenticationToken }) => {
      this.setState({
        credentials: {
          email,
          authenticationToken
        }
      })
    }

    setUser = user => {
      if (user) {
        this.setState({
          firstName: user.firstName
        })
      }
    }

    setUserAddresses = addresses => {
      if (addresses) {
        this.setState({
          userAddresses: addresses
        })
      }
    }

    toggleWarningModal = (modalProps) => {
      this.setState({
        warningModalProps: modalProps
      })
    }

    toggleModalSheet = (modal, emptyQueue = false) => {
      this.setState(prevState => {
        const { modalSheetProps } = prevState

        // Esvazia a fila de modais antecessores, fechando o modalSheet

        if (emptyQueue) {
          return {
            modalSheetProps: {
              modalQueue: [],
              currentModal: {
                visible: false
              }
            }
          }
        }

        // Salva array de modais passados, caso seja necessário voltar em um fluxo anterior do modal,
        // exibindo sempre o modal mais recente da fila

        const modalQueue = modal
          ? modalSheetProps.modalQueue.concat(modal)
          : modalSheetProps.modalQueue.slice(0, -1)

        const currentModal = modal || (modalQueue.length ? modalQueue[modalQueue.length - 1] : {})

        return {
          modalSheetProps: {
            ...modalSheetProps,
            modalQueue,
            currentModal: {
              ...currentModal,
              visible: !!modalQueue.length
            }
          }
        }
      })
    }

    openActionModal = (modalType, params, onSuccess) => {
      this.setState({
        actionModalStack: [...this.state.actionModalStack, { modalType, params, onSuccess }]
      })
    }

    closeActionModal = () => {
      const { actionModalStack } = this.state
      this.setState({
        actionModalStack: [...actionModalStack.slice(0, actionModalStack.length - 1)]
      })
    }

    render () {
      return (
        <RootContext.Provider
          value={{
            ...this.state,
            hideLoader: this.hideLoader,
            showLoader: this.showLoader,
            toggleMenu: this.toggleMenu,
            getProfile: this.getProfile,
            getProfileAddresses: this.getProfileAddresses,
            logoutUser: this.logoutUser,
            setCredentials: this.setCredentials,
            setResetPasswordData: this.setResetPasswordData,
            setUser: this.setUser,
            toggleModalSheet: this.toggleModalSheet,
            toggleWarningModal: this.toggleWarningModal,
            openActionModal: this.openActionModal,
            closeActionModal: this.closeActionModal
          }}
        >
          {this.props.children}
        </RootContext.Provider>
      )
    }
}
